// A frog, modelled facing +X: a squat green body, bulging eyes on top and folded
// hind legs. Ported 1:1 from age-of-mcp's classic frog.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.IcosahedronGeometry(0.024, 0), color: "#4f9e3f",
      position: [0, 0.018, 0], scale: [1.3, 0.8, 1.1] },              // body
    { geometry: new THREE.IcosahedronGeometry(0.008, 0), color: "#6fc257",
      position: [0.014, 0.034, 0.012] },                             // eye bump
    { geometry: new THREE.IcosahedronGeometry(0.008, 0), color: "#6fc257",
      position: [0.014, 0.034, -0.012] },
    { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#0a0a0a",
      position: [0.02, 0.037, 0.012] },                              // pupil
    { geometry: new THREE.IcosahedronGeometry(0.004, 0), color: "#0a0a0a",
      position: [0.02, 0.037, -0.012] },
    { geometry: new THREE.IcosahedronGeometry(0.01, 0), color: "#458a37",
      position: [-0.018, 0.012, 0.018], scale: [1.4, 0.7, 1] },       // folded hind leg
    { geometry: new THREE.IcosahedronGeometry(0.01, 0), color: "#458a37",
      position: [-0.018, 0.012, -0.018], scale: [1.4, 0.7, 1] },
  ];
}

export const frog = defineModel({
  id: "frog",
  batchId: "standard",
  name: "Frog",
  tags: ["creature","frog","low-poly","age-of-mcp","classic","water"],
  summary: "Low-poly frog.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.05,
  parts: () => partsFor(),
  animations: [],
});
